import { SimpleGrid } from "@chakra-ui/react";
import { StaffRoutes } from "appRoutePaths";
import useAdminDashboard from "hooks/useAdminDashboard";
import { centsToDollars } from "util/helpers";
import AdminDashboardCard from "./AdminDashboardCard";

const useAdminDashboardData = () => {
    const data = useAdminDashboard();

    const {
        pendingPackages,
        activeCardsAuctions,
        openSupportTickets,
        totalCustomerBalanceInCents,
        cardsInQA,
        cardsToBeUploaded,
        assignedBatchesToPull
    } = data;

    const pendingPackagesValue = `${pendingPackages.toLocaleString()} Packages`;
    const activeCardsAuctionsValue = activeCardsAuctions.toLocaleString();
    const openSupportTicketsValue = `${openSupportTickets?.toLocaleString()} Open tickets`;
    const totalCustomerBalanceValue = centsToDollars(
        totalCustomerBalanceInCents
    );
    const cardsInQAValue = cardsInQA.toLocaleString();
    const cardsToBeUploadedValue = cardsToBeUploaded.toLocaleString();
    const assignedBatchesToPullValue = assignedBatchesToPull.toLocaleString();

    return {
        pendingPackagesValue,
        activeCardsAuctionsValue,
        openSupportTicketsValue,
        totalCustomerBalanceValue,
        cardsInQAValue,
        cardsToBeUploadedValue,
        assignedBatchesToPullValue
    };
};

const AdminDashboardData = (props: { isAdmin: boolean, isStaff: boolean }) => {
    const {
        pendingPackagesValue,
        activeCardsAuctionsValue,
        openSupportTicketsValue,
        totalCustomerBalanceValue,
        cardsInQAValue,
        cardsToBeUploadedValue,
        assignedBatchesToPullValue
    } = useAdminDashboardData();

    return (
        <SimpleGrid columns={2} spacing={6} pb={6}>
            <AdminDashboardCard
                title="Packages to Upload"
                subtitle="Number of packages being processed"
                value={pendingPackagesValue}
                linkText="Go to Packages Page"
                linkTo={StaffRoutes.packages.url}
            />
            <AdminDashboardCard
                title="Cards"
                subtitle="Active number of cards auctions on eBay"
                value={activeCardsAuctionsValue}
                linkText="Go to Cards Page"
                linkTo={StaffRoutes.cards.url}
                showLink={props.isAdmin}
            />
            <AdminDashboardCard
                title="Support Tickets"
                subtitle="Tickets that are unresolved on ZenDesk"
                value={openSupportTicketsValue}
                linkText="Visit ZenDesk"
                linkTo="https://dcsports87.zendesk.com/access/normal"
                external
                showLink={props.isAdmin}
            />
            <AdminDashboardCard
                title="Total Sum of All Customer Balances"
                subtitle="Amount owed if everyone cashed out today"
                value={totalCustomerBalanceValue}
                linkText="Visit Financial Summary Page"
                linkTo={StaffRoutes.financialSummary.url}
                showLink={props.isAdmin}
            />
            <AdminDashboardCard
                title="Card Titles In QA"
                subtitle="Manage card titles in & through the QA process"
                value={cardsInQAValue}
                linkText="Card Title QA"
                linkTo={StaffRoutes.cardTitleQA.url}
                showLink={props.isAdmin || props.isStaff}
            />
            {props.isAdmin && <AdminDashboardCard
                title="Cards To Be Uploaded"
                subtitle="Cards ready to be uploaded to eBay tonight"
                value={cardsToBeUploadedValue}
                linkText="Pending Listings"
                linkTo={StaffRoutes.pendingListings.url}
                showLink
            />}
            {props.isStaff && <AdminDashboardCard
                title="Batches To Pull"
                subtitle="Start pulling assigned shipment batches"
                value={assignedBatchesToPullValue}
                linkText="Assigned Batches"
                linkTo={StaffRoutes.shipmentBatchesToPull.url}
                showLink
            />}
        </SimpleGrid>
    );
};

export default AdminDashboardData;
